import { render, staticRenderFns } from "./EditAnnouncementDialog.vue?vue&type=template&id=2255a3ec&scoped=true&lang=pug"
import script from "./EditAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./EditAnnouncementDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAnnouncementDialog.vue?vue&type=style&index=0&id=2255a3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255a3ec",
  null
  
)

export default component.exports